import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const TagOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M18.91 2.94h-.19l-5.12.45c-.6.05-1.17.32-1.6.75l-9.27 9.27c-.3.3-.27.84.09 1.19l6.58 6.58c.19.19.44.29.67.29.19 0 .38-.07.51-.2L19.85 12c.43-.43.69-.99.75-1.6l.45-5.12a2.15 2.15 0 0 0-2.14-2.34Zm.1 7.32c-.02.23-.12.44-.28.61l-8.69 8.69-5.6-5.6 8.69-8.69a.99.99 0 0 1 .61-.28l5.12-.45h.05c.21 0 .34.11.4.18.07.08.16.22.14.42L19 10.26h.01Z" />
      <Path d="M15.83 9.99a1.65 1.65 0 1 0 0-3.3 1.65 1.65 0 0 0 0 3.3Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default TagOutlined
